var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/Objects/Objects.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["objects", "additional_objects", "button_text", "btn_type", "isMobile", "mods"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("objects", Object.prototype.hasOwnProperty.call(kwargs, "objects") ? kwargs["objects"] : []);frame.set("additional_objects", Object.prototype.hasOwnProperty.call(kwargs, "additional_objects") ? kwargs["additional_objects"] : []);frame.set("button_text", Object.prototype.hasOwnProperty.call(kwargs, "button_text") ? kwargs["button_text"] : "");frame.set("btn_type", Object.prototype.hasOwnProperty.call(kwargs, "btn_type") ? kwargs["btn_type"] : "btn");frame.set("isMobile", Object.prototype.hasOwnProperty.call(kwargs, "isMobile") ? kwargs["isMobile"] : runtime.contextOrFrameLookup(context, frame, "False"));frame.set("mods", Object.prototype.hasOwnProperty.call(kwargs, "mods") ? kwargs["mods"] : []);var t_2 = "";t_2 += "\n    <div class=\"Objects ";
frame = frame.push();
var t_5 = runtime.contextOrFrameLookup(context, frame, "mods");
if(t_5) {t_5 = runtime.fromIterator(t_5);
var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("m", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
t_2 += "Objects--";
t_2 += runtime.suppressValue(t_6, env.opts.autoescape);
t_2 += " ";
;
}
}
frame = frame.pop();
t_2 += "\">\n        <div class=\"Objects-items owl-carousel\">\n            ";
frame = frame.push();
var t_9 = runtime.contextOrFrameLookup(context, frame, "objects");
if(t_9) {t_9 = runtime.fromIterator(t_9);
var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("item", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
t_2 += "\n                <a class=\"Objects-item u-Route\" href=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((t_10),"url"), env.opts.autoescape);
t_2 += "\">\n                    <img class=\"Objects-itemImg\" src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_10),"img")),"w300"), env.opts.autoescape);
t_2 += "\"\n                         srcset=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_10),"img")),"w400"), env.opts.autoescape);
t_2 += " 400w, ";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_10),"img")),"w600"), env.opts.autoescape);
t_2 += " 600w, ";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_10),"img")),"w800"), env.opts.autoescape);
t_2 += " 800w\">\n                    <div class=\"Objects-itemTitle\">";
t_2 += runtime.suppressValue(runtime.memberLookup((t_10),"title"), env.opts.autoescape);
t_2 += "</div>\n                </a>\n            ";
;
}
}
frame = frame.pop();
t_2 += "\n        </div>\n        ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "additional_objects"))) {
t_2 += "\n            <div class=\"Objects-items Objects-items--additional\">\n                ";
frame = frame.push();
var t_13 = runtime.contextOrFrameLookup(context, frame, "additional_objects");
if(t_13) {t_13 = runtime.fromIterator(t_13);
var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("item", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
t_2 += "\n                    <a class=\"Objects-item u-Route\" href=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((t_14),"url"), env.opts.autoescape);
t_2 += "\">\n                        <img class=\"Objects-itemImg\" src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"img")),"w300"), env.opts.autoescape);
t_2 += "\"\n                             srcset=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"img")),"w400"), env.opts.autoescape);
t_2 += " 400w, ";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"img")),"w600"), env.opts.autoescape);
t_2 += " 600w, ";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"img")),"w800"), env.opts.autoescape);
t_2 += " 800w\">\n                        <div class=\"Objects-itemTitle\">";
t_2 += runtime.suppressValue(runtime.memberLookup((t_14),"title"), env.opts.autoescape);
t_2 += "</div>\n                    </a>\n                ";
;
}
}
frame = frame.pop();
t_2 += "\n            </div>\n        ";
;
}
t_2 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "btn_type") == "link") {
t_2 += "\n            <a class=\"Objects-more u-Route\" href=\"";
t_2 += runtime.suppressValue((lineno = 23, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:buy-flat"])), env.opts.autoescape);
t_2 += "\">";
if(runtime.contextOrFrameLookup(context, frame, "isMobile")) {
t_2 += "Больше\n                объектов";
;
}
else {
t_2 += "Показать\n                больше ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "button_text"), env.opts.autoescape);
;
}
t_2 += "</a>\n        ";
;
}
else {
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "objects")) > 3) {
t_2 += "\n            <div class=\"Objects-more\">";
if(runtime.contextOrFrameLookup(context, frame, "isMobile")) {
t_2 += "Больше объектов";
;
}
else {
t_2 += "Показать\n                больше ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "button_text"), env.opts.autoescape);
;
}
t_2 += "</div>\n        ";
;
}
;
}
t_2 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("Objects");
context.setVariable("Objects", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/Objects/Objects.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Objects/Objects.jinja
// module id = 17
// module chunks = 0